import { render, staticRenderFns } from "./Motoboy.vue?vue&type=template&id=48bdac12"
import script from "./Motoboy.vue?vue&type=script&lang=js"
export * from "./Motoboy.vue?vue&type=script&lang=js"
import style0 from "./Motoboy.vue?vue&type=style&index=0&id=48bdac12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports